import React from "react";
import { AddVestingContainer } from "../../../containers";

const AddVesting = (props) => {
  return <AddVestingContainer {...props} />;
};

export default AddVesting;
